import * as React from "react";
import type { SVGProps } from "react";
const SvgWorldWithAirplane = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.683 21.995Q10.842 22 11 22a1 1 0 0 0 .152-1.988A16 16 0 0 1 9.497 16H11a1 1 0 0 0 0-2H9.112a16 16 0 0 1-.001-4h3.778q.119.994.111 2a1 1 0 0 0 2 0 18 18 0 0 0-.097-2h3.843c.167.648.254 1.32.254 2a1 1 0 0 0 2 0 10 10 0 1 0-10.616 9.981 1 1 0 0 0 .3.014M9.495 8h3.027a16 16 0 0 0-1.491-3.808A16 16 0 0 0 9.495 8m8.433 0H14.58a18 18 0 0 0-1.223-3.645A8 8 0 0 1 17.928 8m-9.22 11.664A18 18 0 0 1 7.436 16H4.072a8 8 0 0 0 4.635 3.664M7.096 14a18 18 0 0 1-.001-4H3.254a8 8 0 0 0 0 4zm.339-6H4.072a8 8 0 0 1 4.633-3.664A18 18 0 0 0 7.435 8"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m20.4 14.84-2.16 1.25-3.83-2.25a1 1 0 0 0-1 0 1 1 0 0 0-.19 1.56l2.33 2.25-1.08.62-1.29-.35a1 1 0 0 0-.79.11 1 1 0 0 0-.17 1.67l1.87 1.66L21.65 17a1.25 1.25 0 0 0 .46-1.7 1.26 1.26 0 0 0-1.71-.46"
    />
  </svg>
);
export default SvgWorldWithAirplane;
